export default "__VITE_ASSET__0bf9bc0d__"